import { SelectionElementType } from '../components/Outlines/types';
import { FONT_DEFAULT_VALUE, getFontByLocation } from '@/Pages/Clip/SideBar/FontSelector/constants';
import { getCurrentClipFontName, getFontNameFromBrandKit } from '@/stores/brandKit';
import { Clip } from '@/domains/asset';

// TODO: @AshwinBhatkal to test cases with just extracting from font location
export const getFontFamilyStyle = (clipId: string, fontLocation?: string) => {
  const fontItem = getFontByLocation(fontLocation);
  if (fontItem) {
    return fontItem.name;
  }
  // No standard font, get from brand kit
  const currentClipFontName = getCurrentClipFontName(clipId, fontLocation);
  if (currentClipFontName) {
    return currentClipFontName;
  }

  const brandKitFontName = getFontNameFromBrandKit(fontLocation);
  if (brandKitFontName) {
    return brandKitFontName;
  }

  return undefined;
};

export const getFontLocationFromAssetMetadata = (
  assetMetadata: Clip['asset_metadata'],
  fontTarget: SelectionElementType
) => {
  if (fontTarget === SelectionElementType.SPEAKER_LABEL) {
    return assetMetadata.speaker_label_styles?.font_location || FONT_DEFAULT_VALUE.url;
  }
  if (fontTarget === SelectionElementType.SPEAKER_LABEL_TITLE) {
    return (
      assetMetadata.speaker_label_styles?.title_font_location ||
      assetMetadata.speaker_label_styles?.font_location ||
      FONT_DEFAULT_VALUE.url
    );
  }
  return assetMetadata?.caption_styles?.font_location || assetMetadata?.font_location || FONT_DEFAULT_VALUE.url;
};
